import { render, staticRenderFns } from "./company.vue?vue&type=template&id=34881eac&scoped=true"
import script from "./company.vue?vue&type=script&lang=ts"
export * from "./company.vue?vue&type=script&lang=ts"
import style0 from "@/styles/list.scss?vue&type=style&index=0&id=34881eac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34881eac",
  null
  
)

export default component.exports